import appManager from '../../../../app/appManager';

export const logger = appManager.logger('manager-assist');

export const HashRegex = /{{hash}}/g;

export const MANAGER_ASSIST_LS_KEY = 'ccpro-manager-assist-{{hash}}';

export const MANAGER_ASSIST_LS_ACCEPTED = 'accepted';
